import { observable, toJS, runInAction, autorun, computed } from 'mobx';
import { task } from 'mobx-task';
import { IUserStoreImpl, IUserForCountry } from './interface';
import RootStore from '../rootStore';
import { profile, IProfile, Gender } from 'src/crud/profile.crud';
import { IConfigurationResponse } from 'src/modules/api';
import { isNil } from 'lodash';
import { IApiContract, getCurrentContract } from 'src/crud/contract.crud';
export class UserStore implements IUserStoreImpl{
  public rootStore: RootStore;  
  @observable public data: IProfile;
  @observable public id: number;
  @observable public configurationData: IConfigurationResponse;
  public fetchUserAsync = task(async () => {
    try {
      const [userProfile, userCurrentContract] = await Promise.all([profile(), getCurrentContract()])
      runInAction(() => {
        this.data = userProfile.data.result;
        this.currentContractData = userCurrentContract.data.result;
      });
    } catch (error) {
      // TODO
    }
  });

  @observable private currentContractData: IApiContract;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    // autorun(() => {
    //   const data$ = toJS(this.data);
    //   const id$ = toJS(this.id);
    //   console.log({ data$, id$ });
    // });
  }
  
  set user(data: IProfile) {
    this.data = data;
  }

  set setUserId(id: number | string) {
    this.id = +id;
  }

  get userEnName() {
    if(!this.fetchUserAsync.resolved) {
      return '';
    }
    const { nameEn } = toJS(this.data);
    return nameEn;
  }

  get userName() {
    if(!this.fetchUserAsync.resolved) {
      return '';
    }
    const { name, surname } = toJS(this.data);
    return surname + name;
  };

  get userGender() {
    if(!this.fetchUserAsync.resolved) {
      return '';
    }
    const { gender } = toJS(this.data);
    return gender
  };

  get userBirthMonthDay() {
    if(!this.fetchUserAsync.resolved) {
      return '';
    }
    if (!toJS(this.data)) {
      return '';
    }

    const { birthMonthDay } = toJS(this.data);
    return birthMonthDay
  };

  get userEnFullName() {
    if(!this.fetchUserAsync.resolved) {
      return '';
    }
    if (!toJS(this.data)) {
      return '';
    }
    const { nameEn, surnameEn } = toJS(this.data);

    if (nameEn === null) {
      return surnameEn
    } else if (surnameEn === null) {
      return nameEn
    } else if (nameEn === null && surnameEn === null) {
      return ''
    } else {
      return nameEn + ' ' + surnameEn
    }
  };

  get userEmail() {
    if(!this.fetchUserAsync.resolved) {
      return '';
    }
    const { emailAddress } = toJS(this.data);
    return emailAddress
  };

  get userComment() {
    const userData = toJS(this.data);
    const id = toJS(this.id);
    if (userData !== undefined) {
      return {
        id,
        name: userData.surname + userData.name,
        profilePictureId: userData.profilePictureId,
      }
    }
    return {
      id: 0,
      name: '',
      profilePictureId: '',
    }
  };

  get userIntroduction() {
    if(!this.fetchUserAsync.resolved) {
      return '';
    }
    const userData = toJS(this.data);
    return userData.introduction;
  }

  get userLanguage() {
    return this.rootStore.authenticateStore.currentLanguage;
  }

  get userIsActive() {
    return toJS(this.data).isActive;
  }

  @computed public get userForCountry(): Partial<IUserForCountry> {
    const data = toJS(this.data);
    if (isNil(data)) {
      return {};
    }

    
    const currentContract = this.currentContract;
    const currentLanguage = this.rootStore.authenticateStore.currentLanguage;
    
    const houseName = currentContract?.houseName ?? '';
    const roomBedName = currentContract?.roomBedName ?? '';

    switch(currentLanguage.name) {
      case 'en': {
        return {
          fullName: this.getFullNameEn(data.nameEn, data.surnameEn),
          userName: data.userName,
          gender: data.gender,
          profilePictureId: data.profilePictureId,
          phoneNumber: data.phoneNumber,
          houseName,
          roomBedName,
          surname: data.surnameEn,

        }
      }
      case 'ko': {
        return {
          fullName: (data.surname ?? '') + (data.name ?? ''),
          userName: data.userName,
          gender: data.gender,
          profilePictureId: data.profilePictureId,
          phoneNumber: data.phoneNumber,
          houseName,
          roomBedName,
          surname: data.surname,
        }
      }
      default: {
        return {
          fullName: this.getFullNameEn(data.nameEn, data.surnameEn),
          userName: data.userName,
          gender: data.gender,
          profilePictureId: data.profilePictureId,
          phoneNumber: data.phoneNumber,
          houseName,
          roomBedName,
          surname: data.surname,
        }
      }
    }
  };

  get profilePictureId() {
    if(!this.fetchUserAsync.resolved) {
      return '';
    }
    const { profilePictureId } = toJS(this.data);

    return profilePictureId
  };
  
  get userId() {
    return toJS(this.id);
  };

  @computed
  get currentContract()  {
    const currentContract = toJS(this.currentContractData);
    if (isNil(currentContract)) {
      return null;
    }
    return currentContract;
  }

  private getFullNameEn = (nameEn: string | undefined | null, surnameEn: string | undefined | null) => {
    let name = '';
    let surname = '';

    if (nameEn !== null && nameEn !== undefined && nameEn !== '') {
      name = nameEn;
    }
    if (surnameEn !== null && surnameEn !== undefined && surnameEn !== '') {
      surname = surnameEn;
    }

    if (surname !== '' && name !== '') {
      return name + ' ' + surname;
    }

    return name + surname;
  }
}



// WEBPACK FOOTER //
// ./src/stores/user/index.ts